import { Typography } from '@mui/material';
import React from 'react';

interface IAuditCardDateValueProps {
	value: string;
}

const AuditCardDateValue: React.FC<IAuditCardDateValueProps> = ({ value }) => (
	<Typography
		variant="subtitle1"
		display="inline"
		data-testid="audit-card-item-date"
	>
		{intl.formatDateTime(value)}
	</Typography>
);

export default AuditCardDateValue;
